import type { HeadDescriptor } from './HeadDescriptor.js';
import { absolutizar } from './absolutizar.js';
import type { SiteInfo } from './jsonld.js';

/**
 * `<head>` base del sitio. Cada loader mergea el suyo encima con `mergeHead`.
 * Los datos del tenant (nombre, logo, dominio) los va a proveer la API cuando exista
 * el endpoint público de tenant; hoy salen del host del request.
 */
export function defaultHead(site: SiteInfo, path = '/'): HeadDescriptor {
  return {
    title: site.name,
    description: `Noticias de la Patagonia — ${site.name}`,
    canonical: `${site.url}${path}`,
    robots: 'index,follow',
    locale: 'es_AR',
    openGraph: {
      type: 'website',
      siteName: site.name,
      url: `${site.url}${path}`,
      locale: 'es_AR',
      // Absoluta: el `og:image` lo lee un scraper que no resuelve rutas relativas.
      ...(site.logoUrl ? { image: absolutizar(site.url, site.logoUrl) } : {}),
    },
    twitter: { card: 'summary_large_image' },
  };
}
